__webpack_require__.p = "https://demo.okoinsights.ai/";